export function buildProblemSharedDataId(id: string) {
  return ["problem", id].join("+");
}

export function buildQuizSharedDataId(groupId: string, participantId: string) {
  return ["quiz", groupId, participantId].join("+");
}
